{
    "dashboard": {
        "addDashboard": "Legg til dashboard",
        "alreadyExists": "Dashboard med navnet {dashboardName} finnes allerede.",
        "confirmDeleteMessage": "Er du sikker på at du vil slette",
        "copyDashboard": "Kopier dashboard",
        "copyDashboardSuccess": "Dashboard kopiert",
        "dashboard": "Dashboard",
        "dashboardDesc": "Dashboard beskrivelse",
        "searchDashboards": "Søk i dashboards",
        "dashboardId": {
            "noWidgetsInDashboard": "Det finnes ingen widgets i dette dashboardet",
            "noWidgets": "Det finnes ingen widgets i ",
            "noWidgetsAdded": "Ingen widgets er lagt til ennå.\nKlikk på en widget over og \ndra den inn for å opprette en widget.",
            "updateRoleSuccess": "Rolle oppdatert",
            "widget": {
                "addCondition": "Legg til betingelse",
                "barChart": "Søyle",
                "chartType": "Diagramtype",
                "column": "Kolonne",
                "copyToDashboard": "Kopier til dashboard",
                "copyWidget": "Kopier widget",
                "copyWidgetSuccess": "Widget kopiert",
                "count": "Antall",
                "dataset": "Velg datasett for widgeten",
                "deleteCondition": "Slett betingelse",
                "deleteWidgetSuccess": "Widget slettet",
                "display": "Vis",
                "editWidget": "Rediger widget",
                "exportScheduled": "Eksport planlagt. Du får en varsling når den er klar",
                "field": "Felt",
                "goAheadAndSearchForRecordsIn": "Søk etter poster i",
                "infoBox": "Infoboks",
                "itemColor": "Farge på element",
                "items": "Elementer",
                "label": "Etikett",
                "lineChart": "Linje",
                "newWidget": "Ny widget",
                "noRecordsToDisplay": "Ingen poster å vise.",
                "noDataAvailable": "Ingen tilgjengelige data",
                "notLinked": "Ikke koblet",
                "notPossibleToDownload": "For mye data til å laste ned",
                "noWidgets": "Ingen widgets ",
                "number": "Tall",
                "optionalDescription": "Valgfri widgetbeskrivelse",
                "optionalDescriptionWidget": "Valgfri widgetbeskrivelse",
                "show": "Vis",
                "table": "Tabell",
                "tabMenu": {
                    "addField": "Legg til feltnavn",
                    "activeWidget": "aktiv widget",
                    "addRule": "Legg til regel",
                    "addViewDetailsButton": "Legg til Vis detaljer knapp",
                    "advancedFilter": "Avansert filter",
                    "advancedCondition": "Avansert betingelse",
                    "advancedFilterInfoTooltip": "Detaljert info om filterspørringer",
                    "appName": "Appnavn",
                    "appUrl": "App-URL",
                    "advancedFilterQueryGuide": {
                        "and": "Og",
                        "andDescription": "AND viser en post hvis alle betingelser er sanne.",
                        "andExample": "ItemType:Ext AND Status:[10 TO 20]",
                        "between": "Mellom",
                        "betweenDescription": "I SQL brukes BETWEEN-operatøren til å filtrere verdier innenfor et område.",
                        "betweenExample": "Status:[10 TIL 20]",
                        "dateModifications": "Endringer basert på dato:",
                        "dateModificationsTitle": "1. Vis data endret de siste 3 dagene",
                        "dateModificationsTitleEx": "__modified: [\"now-3d/d\" TO \"now/d\"]",
                        "dateModificationsTitle1": "2. Vis rader opprettet 2025-02-04",
                        "dateModificationsTitleEx1": "__created: \"2025-02-04\"",
                        "equalTo": "Lik (=)",
                        "equalToDescription": "Henter poster hvor ItemNumber er 3000007.",
                        "equalToExample": "ItemNumber:3000007",
                        "example": "Eksempel:",
                        "example1": "Eksempel 1:",
                        "example2": "Eksempel 2:",
                        "exists": "Eksisterer",
                        "existsExample": "_ItemType:*",
                        "existsNotExists": "Eksisterer / Eksisterer ikke",
                        "existsNotExistsDescription": "Ingen direkte EXISTS funksjon, bruk feltkontroll.",
                        "greaterThan": "Større enn (>)",
                        "greaterThanDescription": "Henter opp poster der Status er større enn 20.",
                        "greaterThanExample": "Status:>10",
                        "greaterThanOrEqualTo": "Større enn eller lik (>=)",
                        "greaterThanOrEqualToDescription": "Henter opp poster der Status er større enn eller lik 20.",
                        "greaterThanOrEqualToExample": "Status:>=10",
                        "in": "I",
                        "inDescription": "IN spesifiserer flere verdier. Her brukes OR.",
                        "inExample": "ItemNumber:(3000007 OR 3000047)",
                        "introductionDescription": "Veiledning for avanserte filterspørringer i OpenSearch.",
                        "introductionTitle": "Introduksjon",
                        "lessThan": "Mindre enn (<)",
                        "lessThanDescription": "Henter opp poster der Status er mindre enn 20.",
                        "lessThanExample": "Status:<20",
                        "lessThanOrEqualTo": "Mindre enn eller lik (<=)",
                        "lessThanOrEqualToDescription": "Henter opp poster der Status er mindre enn eller lik 20.",
                        "lessThanOrEqualToExample": "Status:<=20",
                        "like": "Som",
                        "likeDescription": "I SQL brukes LIKE-operatoren for mønstergjenkjenning. Her bruker du jokertegnene * og ?.",
                        "likeExample": "ItemNumber:300*",
                        "linkedSearchWidgetTitle": "Eksempel for koblet søkewidget",
                        "notEqualTo": "Ikke lik (!=)",
                        "notEqualToDescription": "Henter poster hvor ItemNumber ikke er 3000007.",
                        "notEqualToExample1": "!ItemNumber:3000007",
                        "notEqualToExample2": "!ItemNumber:3000007",
                        "notExists": "Eksisterer ikke",
                        "notExistsExample": "-_ItemType:*",
                        "operatorsTitle": "Operatorer:",
                        "or": "ELLER",
                        "orDescription": "OR viser en post hvis minst én betingelse er sann.",
                        "orExample": "ItemType:Ext OR (Status:[15 TO 25])",
                        "tagValue": "Eksempel for tag-verdi",
                        "tagValueExample": "ItemType: {{ tags.[ItemType] }}",
                        "tagValueExample1": "ProductGroup: {{ tags.[Product Group] }}",
                        "where": "Hvor",
                        "whereDescription": "WHERE filtrerer poster. Her brukes Felt:Verdi.",
                        "whereExample": "ItemNumber:3000007"
                    },
                    "appearance": "Utseende",
                    "backgroundColor": "Bakgrunnsfarge",
                    "boldText": "Uthevet tekst",
                    "charts": {
                        "barChart": "Søylediagram",
                        "cakeChart": "Kakediagram",
                        "lineChart": "Linjediagram"
                    },
                    "chooseDataset": "Velg datasett",
                    "chooseWorkflow": "Velg workflow",
                    "chooseEvent": "Velg hendelse",
                    "customBackgroundColor": "Egendefinert bakgrunnsfarge",
                    "data": "Data",
                    "dataFieldComparison": "Datafelt sammenligning",
                    "dataWarningRules": "Datavarsel regler",
                    "defaultBackgroundColor": "Standard bakgrunnsfarge",
                    "details": "Detaljer",
                    "filter": "Filter",
                    "filtersHeader": "Filter",
                    "fonts": "Skrifter",
                    "fontSize": "Skriftstørrelse",
                    "fontSizeForTitle": "Skriftstørrelse for tittel",
                    "foregroundColor": "Tekstfarge",
                    "from": "Fra",
                    "iconLeft": "Ikon venstre",
                    "iconLeftSize": "Ikonstørrelse venstre",
                    "iconPosition": "Ikonposisjon",
                    "iconRight": "Ikon høyre",
                    "iconRightSize": "Ikonstørrelse høyre",
                    "iconSize": "Ikonstørrelse",
                    "linked": "koblet",
                    "linkedWidgets": "Koblede widgets",
                    "linkedWidgetsDescription": "Velg widgets som skal kobles med inngangsdata",
                    "linkFrom": "Koblet fra",
                    "linkFromFieldCaption": "Velg kildewidget som utløser data",
                    "mandatoryDatasetForWidget": "Påkrevd datasett",
                    "eventForWidget": "Hendelse brukt som datakilde",
                    "mandatoryField": "Påkrevd felt",
                    "name": "Navn",
                    "operators": {
                        "average": "Gj.snitt",
                        "max": "Maks",
                        "min": "Min",
                        "sum": "Sum"
                    },
                    "optionalDescriptionOfTheDashboard": "Valgfri dashboard beskrivelse",
                    "searchTableColumnsPlaceholder": "Søk i tabellkolonner",
                    "tableColumn": "Tabellkolonner",
                    "select": "Velg",
                    "selectAll": "Velg alle",
                    "dragDropTableColumns": "Dra og slipp for å bestemme kolonnerekkefølge. Minst én kolonne må velges.",
                    "selectDivider": "Velg skillelinje",
                    "selectIcon": "Velg ikon",
                    "selectIconSize": "Velg ikonstørrelse",
                    "selectLeftIcon": "Velg venstre ikon",
                    "selectLinkedWidgets": "Velg koblede widgets",
                    "selectRightIcon": "Velg høyre ikon",
                    "selectWidget": "Velg widget",
                    "showFilters": "Vis filtre",
                    "showViewDetailsButton": "Vis detaljer knapp",
                    "simpleFilter": "Enkelt filter",
                    "sqlBasedCodeQuery": "Spørring",
                    "closeSqlHelper": "Lukk spørringshjelper",
                    "showSqlHelper": "Vis spørringshjelper",
                    "tagFieldComparison": "Tag sammenligning",
                    "text": "Tekst",
                    "to": "Til",
                    "widgetData": "Widget data",
                    "widgetDataset": "Widget datasett",
                    "widgetDescription": "Widget beskrivelse",
                    "widgetName": "Widget navn",
                    "workflows": "Workflows",
                    "connectedWorkflow": "Koblet workflow",
                    "workflowsInputSettings": "Input innstillinger",
                    "triggerExpression": "Trigger uttrykk",
                    "triggerExpressionInfo": "JSONata uttrykk for workflow input. Kan inkludere ",
                    "triggerExpressionInfo1": " for koblede data\n",
                    "dataExpression": "Datauttrykk",
                    "dataExpressionInfo": "Brukes for å hente data fra workflow respons",
                    "descriptionExpression": "Beskrivelse uttrykk",
                    "descriptionExpressionInfo": "Brukes for å hente beskrivelsestekst",
                    "workflowResultSettings": "Workflow resultatinnstillinger",
                    "workflowResultSettingsInfo": "Alle innstillingene under er ",
                    "workflowResultSettingsInfo1": " og bruker JSONpath eller JSONata",
                    "optional": "VALGFRITT",
                    "detailsDataExpression": "Uttrykk for detaljer data",
                    "detailsDataExpressionInfo": "Brukes når man klikker på ",
                    "detailsDataExpressionInfo1": " i enkelte widgets",
                    "viewDetails": "Vis detaljer",
                    "detailsTextExpression": "Detaljtekst uttrykk",
                    "detailsTextExpressionInfo": "Vises i stedet for ",
                    "detailsTextExpressionInfo1": " i enkelte widgets",
                    "detailsUrlExpression": "Detalj URL uttrykk",
                    "detailsUrlExpressionInfo": " brukes når man klikker på ",
                    "detailsUrlExpressionInfo1": " i enkelte widgets",
                    "schemaDefinitionExpression": "Skjemadefinisjon uttrykk",
                    "enableSelection": "Aktiver valg",
                    "multipleRows": "Flere rader",
                    "singleRow": "En rad",
                    "editableTable": "Redigerbar tabell",
                    "selectEditableFields": "Velg redigerbare felt",
                    "typeEditableFields": "Skriv og trykk enter for å legge til felt",
                    "useDropdown": "Bruk rullegardinliste",
                    "selectDropdownColumn": "Velg rullegardinkolonne",
                    "selectColumn": "Velg kolonne",
                    "dropdownColumnName": "Rullegardinkolonnenavn",
                    "enterColumnName": "Skriv inn kolonnenavn",
                    "addDropdownValue": "Legg til rullegardinverdi",
                    "typeDropdownValues": "Skriv og trykk enter for å legge til verdier",
                    "actions": "Handlinger",
                    "manageActions": "Administrer handlinger",
                    "actionSettings": "Handlingsinnstillinger",
                    "listOfActions": "Handlingsliste",
                    "addNewAction": "Legg til handling",
                    "noActionsYet": "Ingen handlinger ennå",
                    "actionName": "Handlingsnavn",
                    "actionDescription": "Handlingsbeskrivelse",
                    "selectWorkflow": "Velg workflow",
                    "advancedWorkflowSettings": "Avanserte workflow innstillinger",
                    "triggerAction": "Utløs handling",
                    "triggerActionInfo": "JSONata uttrykk for input. Kan inkludere $selected og $linked",
                    "removeRowFromTable": "Fjern rad fra tabell",
                    "removeOnSuccess": "Fjern ved suksess",
                    "removeOnFailure": "Fjern ved feil",
                    "verifyBeforeAction": "Bekreft før handling",
                    "chooseChart": "Velg diagramtype",
                    "eventHandling": "Håndtering av hendelser",
                    "showOnEvent": "Vis ved hendelse",
                    "hideOnEvent": "Skjul ved hendelse",
                    "showOnEventDescription": "Holder widget skjult til hendelsen utløses",
                    "hideOnEventDescription": "Skjuler widget når hendelsen utløses",
                    "transform": "Transformer",
                    "transformDescription": "Transformer inputdata med JSONata. $linked er banen til koblede data.",
                    "event": "Hendelse",
                    "loadWidgetData": "Last widgetdata når dashbordet lastes",
                    "shouldNotLoad": "Skal ikke innledningsvis laste data for denne widgeten",
                    "legacyDatasource": "Hvis du endrer datakilde i den nye versjonen, vil denne endringen være irreversibel. Den anvendte arbeidsflyten vil da kun fungere i den nye versjonen og vil ikke lenger være kompatibel med den eldre versjonen"
                },
                "iconSize": {
                    "extraSmall": "Ekstra liten",
                    "small": "Liten",
                    "medium": "Medium",
                    "large": "Stor"
                },
                "updatedSuccessfully": "Widget oppdatert",
                "viewDetails": "Vis detaljer",
                "widgetDataset": "Widget datasett",
                "widgetCustomTable": "Widget egendefinert tabell",
                "widgetDatasource": "Widget datakilde",
                "widgetChartType": "Diagramtype",
                "widgetWorkflow": "Widget workflow",
                "widgetDescription": "Widget beskrivelse",
                "widgetName": "Widget navn",
                "xAxis": "X akse",
                "yAxis": "Y akse",
                "last": "Siste",
                "first": "Første",
                "dataSource": {
                    "CUSTOM_TABLE": "Egendefinert tabell",
                    "EVENT": "Hendelse",
                    "WORKFLOW": "Workflow"
                },
                "selectCustomTable": "Velg egendefinert tabell",
                "selectWorkflow": "Velg workflow",
                "selectEvent": "Velg hendelse",
                "charts": {
                    "WIDGET_LINE_CHART": "Linjediagram",
                    "WIDGET_BAR_CHART": "Søylediagram",
                    "WIDGET_PIE_CHART": "Kakediagram"
                },
                "linkedTo": "Koblet til",
                "itemSelected": "{item} element valgt",
                "itemsSelected": "{item} elementer valgt",
                "selectAction": "Velg handling",
                "confirmExecute": "Er du sikker på at du vil utføre \"{actionName}\"?",
                "actionSuccessMsg": "{actionName} utført på valgte elementer.",
                "actionFailMsg": "{actionName} feilet. Sjekk workflow logg.",
                "exportItem": "Eksporter {count} element",
                "exportItems": "Eksporter {count} elementer",
                "exportTooltipSingle": "Last ned {count} linje til Excel",
                "exportTooltipMultiple": "Last ned {count} linjer til Excel",
                "showAllItems": "Vis alle elementer",
                "failedToLoadTableData": "Kunne ikke laste tabelldata",
                "failedToLoadDataForWidget": "Kunne ikke laste data for {widgetType} - {widgetName}",
                "failedToLoadInfoboxData": "Kunne ikke laste infoboksdata",
                "noRecordsFound": "Ingen poster funnet",
                "notPossibleToDwonload": "Kan ikke laste ned fil.",
                "filterCompatibility": "Endrer du disse filtrene i den nye versjonen, kan det ikke reverseres.\nFiltrene vil bare virke i ny versjon.",
                "noColumnsSelected": "Ingen kolonner valgt. Velg minst 1 kolonne.",
                "permissionError": "Kan ikke hente data. Nødvendige tillatelser mangler",
                "tagPermissionError": "Kan ikke hente data. En nødvendig tag mangler i tagsammenligning",
                "notPossibleToLoadData": "Ikke mulig å laste inn data"
            }
        },
        "dashboardName": "Dashboard navn",
        "dashboardWidgets": "Dashboard widgets",
        "dataset": "Velg datasett for widget",
        "deleteConfirmation": "Slettebekreftelse",
        "deleteDashboardSuccess": "Dashboard slettet",
        "deleteWidgetSuccess": "Widget slettet",
        "dragAndDropPreview": "Dra og slipp widget i forhåndsvisning",
        "editDashboard": "Rediger dashboard",
        "exitEditMode": "Avslutt redigeringsmodus",
        "loadMore": "Last flere dashboards",
        "mandatoryField": "Påkrevd felt",
        "newDashboard": "Nytt dashboard",
        "noDashboardsOnSearch": "Ingen dashboards samsvarer med søket",
        "noRecords": "Ingen poster å vise",
        "selectDashboard": "Velg dashboard",
        "specialCharError": "Spesialtegn: / $ *? {'{ }'} [] & % er ikke tillatt",
        "title": "Dashboards",
        "widgetDataset": "Widget datasett",
        "widgetDescription": "Widget beskrivelse",
        "widgetPlaceholder": "Widget plassholder",
        "widgetName": "Widget navn",
        "widgetNameCannotBeEmpty": "Widget navn kan ikke være tomt.",
        "widgetPreview": "Widget forhåndsvisning"
    },
    "menuItems": {
        "dashboard": "Dashboards"
    },
    "widget": {
        "addWidget": "Legg til widget",
        "filters": {
            "convertedFilters": "Konverterte filterelementer",
            "convertedAdvanced": "Konvertert avansert filter",
            "editGroupName": {
                "title": "Rediger gruppenavn",
                "label": "Nytt navn"
            },
            "header": "Filter",
            "and": "og",
            "rule": "Regel",
            "connectedWith": "(koblet med {operator})",
            "newFilterName": "Nytt filter",
            "newFilterDescription": "",
            "newGroup": "Ny gruppe",
            "addConditionsList": "Legg til betingelsesliste",
            "addQuery": "Legg til manuell spørring",
            "addFilterItem": "Legg til filter",
            "filterSummary": "FILTEROPPSUMMERING",
            "selectFields": "Felt",
            "selectCondition": "Betingelse",
            "valueType": "Verditype",
            "provided": "Verdi",
            "tag": "Tagg",
            "field": "Felt",
            "noConditions": "Ingen betingelser støttes for valgt felttype",
            "startDate": "Startdato",
            "endDate": "Sluttdato",
            "date": "Dato",
            "range": "Område",
            "logical": {
                "and": "OG",
                "or": "ELLER"
            },
            "conditions": {
                "string": {
                    "EQUALS": "Lik",
                    "GREATER_THAN": "Etter",
                    "GREATER_THAN_OR_EQUALS": "På eller etter",
                    "NOT_EQUALS": "Ikke lik",
                    "CONTAINS": "Inneholder",
                    "DOES_NOT_CONTAIN": "Inneholder ikke",
                    "IS_BLANK": "Er tom",
                    "IS_NOT_BLANK": "Er ikke tom",
                    "LESS_THAN": "Før",
                    "LESS_THAN_OR_EQUALS": "På eller før"
                },
                "array": {
                    "CONTAINS": "Inneholder",
                    "DOES_NOT_CONTAIN": "Inneholder ikke"
                },
                "number": {
                    "EQUALS": "Lik",
                    "NOT_EQUALS": "Ikke lik",
                    "LESS_THAN": "Mindre enn",
                    "LESS_THAN_OR_EQUALS": "Mindre eller lik",
                    "GREATER_THAN": "Større enn",
                    "GREATER_THAN_OR_EQUALS": "Større eller lik"
                },
                "date": {
                    "EQUALS": "Er på",
                    "NOT_EQUALS": "Er ikke på",
                    "CONTAINS": "Inneholder",
                    "DOES_NOT_CONTAIN": "Inneholder ikke",
                    "IS_BLANK": "Er tom",
                    "IS_NOT_BLANK": "Er ikke tom",
                    "LESS_THAN": "Før",
                    "GREATER_THAN": "Etter",
                    "LESS_THAN_OR_EQUALS": "På eller før",
                    "GREATER_THAN_OR_EQUALS": "På eller etter"
                },
                "boolean": {
                    "EQUALS": "Er sann",
                    "NOT_EQUALS": "Er falsk",
                    "CONTAINS": "Er sann",
                    "NOT_CONTAINS": "Er falsk"
                }
            },
            "valueTypes": {
                "PROVIDED": "Manuell",
                "TAG": "Tagger",
                "FIELD": "Sammenlign",
                "CONTEXT": "Kontekst",
                "RELATIVE_DATE": "Relativ dato"
            }
        },
        "filterTab": {
            "addFilter": "Legg til filterregel",
            "editFilter": "Rediger filter",
            "deleteFilter": "Slett filter",
            "appliedFilter": "Filtrering er aktivert",
            "legacyFilterInfo": "Filter fra Vince Live v1 er aktivert",
            "deleteFilterConfirmation": "Er du sikker på at du vil slette filteret?",
            "filterDeleted": "Filter slettet.",
            "noFilters": "Ingen filtre lagt til for denne widgeten"
        },
        "connectedTo": "Koblet til "
    },
    "widgetType": {
        "WIDGET_DISPLAY_BOX": {
            "label": "Visningswidget"
        },
        "WIDGET_INFO_BOX": {
            "label": "Infowidget"
        },
        "WIDGET_LINE_CHART": {
            "label": "Grafwidget"
        },
        "WIDGET_SEARCH_BOX": {
            "label": "Inndataboks"
        },
        "WIDGET_TABLE": {
            "label": "Tabellwidget"
        },
        "WIDGET_MAP": {
            "label": "Kartwidget"
        },
        "WIDGET_WORKFLOW": {
            "label": "Workflow widget"
        }
    }
}
